export default __webpack_public_path__ + "static/media/Lightning.ec179c83.png";